import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonGroup, Button, ButtonToolbar } from 'react-bootstrap';

class ComprobantesToolbarActions extends Component {

  handleOnToggleSelectableItems = () => {
    this.props.onToggleSelectableItems();
  }

  goToComprobanteCreatePage = () => {
    this.props.history.push('/app/comprobantes/timbrado')
  }

  goToTimbradoMasivoPage = () => {
    this.props.history.push('/app/timbrado-masivo')
  }

  render() {
    return (
      <ButtonToolbar aria-label="Toolbar with button groups" className="d-inline-flex">
        <ButtonGroup aria-label="Acciones secundarias">
          <Button variant="secondary" onClick={ this.handleOnToggleSelectableItems }>
            <FontAwesomeIcon icon={ ['fas', 'check'] } />
          </Button>
        </ButtonGroup>
      </ButtonToolbar>
    )
  }
}

export default withRouter(ComprobantesToolbarActions);